import {
  LOAD_QUOTE_DATA,
  LOAD_QUOTE_USER_DATA_SUCCESS,
  CREATE_QUOTE,
  LOAD_QUOTE_FAILURE,
  LOAD_QUOTE_SUCCESS,
  ADD_QUOTE_ADDRESS,
  ADD_QUOTE_ADDRESS_SUCCESS,
  ADD_QUOTE_ADDRESS_FAILURE,
  CREATE_QUOTE_SUCCESS,
  CREATE_QUOTE_FAILURE,
  ORDER_SIMULATE,
  QUOTE_ANALYTICS_ON_LOAD,
  STORE_PREV_SHIP_ADDRESS,
  STORE_PREV_BILL_ADDRESS,
  UPDATE_QUOTE_SHIP_ADDRESS,
  UPDATE_QUOTE_BILL_ADDRESS,
} from './Quote.constants';

export const loadQuoteData = () => ({
  type: LOAD_QUOTE_DATA,
});

export const loadUserDataSuccess = data => ({
  type: LOAD_QUOTE_USER_DATA_SUCCESS,
  data,
});

export const onCreateQuote = body => ({
  type: CREATE_QUOTE,
  body,
});

export const onCreateQuoteSuccess = data => ({
  type: CREATE_QUOTE_SUCCESS,
  data,
});

export const onCreateQuoteFailure = error => ({
  type: CREATE_QUOTE_FAILURE,
  error,
});

export const loadQuoteDataSuccess = data => ({
  type: LOAD_QUOTE_SUCCESS,
  data,
});

export const loadQuoteDataFailure = error => ({
  type: LOAD_QUOTE_FAILURE,
  error,
});

export const addQuoteAddress = (data, onSubmitSuccess, setSelectedAddress) => ({
  type: ADD_QUOTE_ADDRESS,
  data,
  onSubmitSuccess,
  setSelectedAddress,
});

export const addQuoteAddressSuccess = data => ({
  type: ADD_QUOTE_ADDRESS_SUCCESS,
  data,
});

export const addQuoteAddressFailure = data => ({
  type: ADD_QUOTE_ADDRESS_FAILURE,
  data,
});

export const storePrevShipAddress = prevShipAddress => ({
  type: STORE_PREV_SHIP_ADDRESS,
  payload: prevShipAddress,
});
export const storePrevBillAddress = prevBillAddress => ({
  type: STORE_PREV_BILL_ADDRESS,
  payload: prevBillAddress,
});
export const updateQuoteShipAddress = data => ({
  type: UPDATE_QUOTE_SHIP_ADDRESS,
  payload: data,
});
export const updateQuoteBillAddress = data => ({
  type: UPDATE_QUOTE_BILL_ADDRESS,
  payload: data,
});
export const orderSimulate = data => ({
  type: ORDER_SIMULATE,
  data,
});

export const quoteAnalyticsOnLoad = data => ({
  type: QUOTE_ANALYTICS_ON_LOAD,
  data,
});

export default [loadQuoteData];
